export const DEFAULT_BUSINESS_NAME = 'Business'
export const DEFAULT_PERSON_NAME = 'Person'
